/* aurora-drag-scroll.js — click-and-drag (mouse) swiping for every aurora scroll-snap
   carousel: the slideshow/banner, the Dawn slider carousels (featured collection,
   collection list, collection tabs — all use `ul[id^="Slider-"]`), and the PDP gallery.
   Touch devices already swipe natively, so this only runs for fine pointers. One tiny file,
   attached once, re-scanned on section render. No per-section JS. */
(function () {
  if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;

  /* EVERY aurora carousel, so the drag behaviour and the grab cursor are identical in all of
     them. `[id^="Slider-"]` already covers the Dawn-slider ones (featured collection, collection
     list/tabs, multicolumn, blog posts, gallery grid, logo list, button row, announcement bar,
     slideshow, related products); the rest are tracks with their own class.
     NOT listed: .aurora-stl__track (shop the look) and .aurora-sv__track (shoppable video) —
     those ship their own pointer-drag, so adding this one would double-handle every drag.
     They already use the same grab/grabbing cursor, so the icon still matches. */
  var SELECTOR = [
    '.aurora-slideshow__slider',
    '[id^="Slider-"]',
    '.aurora-pdp__media-list',
    '.aurora-pdp__thumbs',
    '.aurora-pdp__reco-list--slider',
    '.aurora-tm__grid',
    '.aurora-lg__grid',
    '.aurora-lk__track',
    '.aurora-fp__thumbs',
    '.aurora-pwb__products',
    '.aurora-cart-up__list--slider'
  ].join(',');
  // NOT links: product cards ARE links, so dragging must scroll the carousel (and we cancel
  // the browser's native link/image drag below). Only real form controls are left alone.
  var IGNORE = 'button, input, select, textarea, [data-aurora-arrow], [data-aurora-zoom]';

  /* Show the grab cursor ONLY where a drag can actually happen. Several of these containers
     are the same element in grid mode (nothing to scroll), and the PDP thumbs are a VERTICAL
     column in the thumbnail-left/right layouts — in both cases scrollWidth === clientWidth,
     so this single check keeps the cursor honest instead of promising a drag that does nothing.
     Mirrors the guard in pointerdown below, so cursor and behaviour can never disagree. */
  function syncCursor(el) {
    el.classList.toggle('aurora-draggable', el.scrollWidth > el.clientWidth + 4);
  }

  function attach(el) {
    if (el.__auroraDrag) return;
    el.__auroraDrag = true;
    syncCursor(el);

    var down = false, moved = false, startX = 0, startScroll = 0, pid = null;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;      // touch = native swipe
      if (e.target.closest(IGNORE)) return;                         // don't hijack real controls
      if (el.scrollWidth <= el.clientWidth + 4) return;             // nothing to scroll
      down = true; moved = false; startX = e.clientX; startScroll = el.scrollLeft; pid = e.pointerId;
    });

    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < 6) return;                               // small threshold before hijack
        moved = true;
        el.classList.add('is-dragging');
        el.style.scrollSnapType = 'none';                           // free scrolling while dragging
        el.style.scrollBehavior = 'auto';
        try { el.setPointerCapture(pid); } catch (_) {}
      }
      el.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    function end() {
      if (!down) return;
      down = false;
      if (moved) {
        el.classList.remove('is-dragging');
        el.style.scrollSnapType = '';                               // restore snap → settles on a slide
        el.style.scrollBehavior = '';
        try { el.releasePointerCapture(pid); } catch (_) {}
        // swallow the click that fires at the end of a drag so links/buttons don't trigger
        el.addEventListener('click', function swallow(ev) {
          ev.stopPropagation(); ev.preventDefault();
          el.removeEventListener('click', swallow, true);
        }, true);
      }
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('pointerleave', end);
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(attach);
  }

  /* Scrollability changes without any DOM change: a section set to grid on desktop and
     carousel on mobile crosses the breakpoint, and card widths settle only once web fonts
     and images have landed. Re-check then, or the cursor stays stuck at its first reading. */
  function refresh() { document.querySelectorAll(SELECTOR).forEach(syncCursor); }
  var queued = false;
  window.addEventListener('resize', function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; refresh(); });
  });
  window.addEventListener('load', refresh);

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); refresh(); });
  // recommendation carousels are injected after load — attach drag to them too
  document.addEventListener('aurora:reco:loaded', function (e) { init((e.detail && e.detail.el) || document); });
})();
